import {messagesService} from "@dv5/api"
import {AddComment} from "../model/AddComment"

export class CommentService {

    private readonly canvasId: string
    private readonly clickedWidgetId: string | null
    private readonly onResetComment: () => void

    constructor(
        canvasId: string,
        clickedWidgetId: string | null,
        onResetComment: () => void) {
        this.canvasId = canvasId
        this.clickedWidgetId = clickedWidgetId
        this.onResetComment = onResetComment
    }

    loadComments(sourceItemId: string) {
        messagesService.send('canvas.get-widget-comments', {
            canvasId: this.canvasId,
            widgetId: sourceItemId,
        })
    }

    sendComment(content: string) {
        if (this.clickedWidgetId) {
            messagesService.send<AddComment>('canvas.add-comment', {
                canvasId: this.canvasId,
                sourceItemId: this.clickedWidgetId,
                content,
            })
            this.onResetComment()
        }
    }

    editComment(commentId: string, content: string) {
        messagesService.send('canvas.edit-widget-comment', {
            canvasId: this.canvasId,
            sourceItemId: this.clickedWidgetId,
            commentId,
            content,
        })
    }

    deleteComment(commentId: string) {
        messagesService.send('canvas.remove-widget-comment', {
            canvasId: this.canvasId,
            sourceItemId: this.clickedWidgetId,
            commentId,
        })
    }
}
